module.exports = __webpack_public_path__ + "img/window-sidebar.832b94a0.svg";